import React from "react";
import PropTypes from "prop-types";

class Hyperlink extends React.Component {
  render() {
    const {
      linkLabel,
      linkOnClick
    } = this.props;

    return (
      <a href="#" onClick={linkOnClick}>
        {linkLabel}
      </a>
    );
  }
}

export default Hyperlink;


// WEBPACK FOOTER //
// ./src/Controls/Hyperlink.js